import { useMutation } from "src/Hooks/useReactQuery";
import { deleteResourceTag } from "src/services/tags-service";

const useDeleteResourceTag = (options = {}) => {
  const { showAlert, t, onSuccess, onError, onSettled, ...restOptions } = options;

  return useMutation({
    mutationFn: (params) => deleteResourceTag(params),
    onSuccess: (data, variables) => {
      if (showAlert && t) {
        showAlert({
          status: true,
          message: t(variables?.params?.item_ids?.length > 1 ? "delete_tag_success" : "delete_tag_success_to_single_resource", {
            resourceLength: variables?.params?.item_ids?.length,
          }),
          type: "success",
        });
      }

      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error) => {
      showAlert({
        status: true,
        message: t("delete_tags_failed"),
        type: "danger",
      });
      if (onError) {
        onError(error);
      }
    },
    onSettled: (data, error) => {
      if (onSettled) {
        onSettled(data, error);
      }
    },
    ...restOptions,
  });
};

export default useDeleteResourceTag;
